export default function(){
    const $trigger = $(".trigger-toaster");
    const $minimize = $(".trigger-minimize");
    const $iconDown = $('.toaster__intro .icon-down');
    let scrollHide = true;

    $trigger.on('click', function() {
        const targetId = $(this).attr('href'); // Get the href attribute of the clicked link
        toggleFull(targetId); // Pass the ID to the toggleFull function
        return false;
    });

    $minimize.on('click', function() {
        toggleMinimize();
        return false;
    });

    $(document).on("scroll", e => {
        if(!$iconDown.hasClass('hidden') && scrollHide) {
            toggleMinimize();
            scrollHide = false;
        }
        return false;
    });
}

function toggleFull(targetId) {
    const $doc = $('html');
    const $full = $('.toaster__full');
    $doc.toggleClass('disablescroll');
    $full.toggleClass('toaster__full--open');

    if ($full.hasClass('toaster__full--open') && targetId && targetId !== '#') {
        // Ensure the modal is fully visible before scrolling
        setTimeout(() => {
            const $target = $(targetId);
            if ($target.length) {
                $('.toaster__full').animate({
                    scrollTop: $target.offset().top - 50 // Adjust this value as necessary for your layout
                }, 1000);
            }
        }, 400); // Adjust timeout as needed to match animation speed
    }
    if(!$full.hasClass('toaster__full--open')){
        // On close reset scroll to zero
        $full.scrollTop(0);
    }
}

function toggleMinimize() {
    const $full = $('.toaster__content');
    const $iconDown = $('.toaster__intro .icon-down');
    const $iconUp = $('.toaster__intro .icon-up');
    $iconDown.toggleClass('hidden');
    $iconUp.toggleClass('hidden');
    $full.toggleClass('toaster__content--minimize');
}